// frontend/src/pages/public/Accessibility/AccessibilityContent.ts

export const accessibilityPage = {
  eyebrow: "Support",
  title: "Accessibility",
  subtitle:
    "We’re committed to improving accessibility so more people can use AcceptingMD with confidence.",

  // ✅ No illustrations shipped yet (keep empty to avoid missing asset paths)
  illustrationSrc: "",

  sections: [
    {
      title: "Our Accessibility Commitment",
      body: [
        "AcceptingMD is committed to providing a website that is accessible to as many people as possible, including people with disabilities.",
        "We aim to follow recognized accessibility standards and continuously improve the experience for all users.",
        "We work to make AcceptingMD perceivable and easy to understand, keyboard accessible, compatible with common assistive technologies (screen readers, zoom tools, etc.), and clear and consistent in layout and navigation.",
        "Where reasonably possible, AcceptingMD aims to align with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA.",
        "We design with accessibility in mind as we build and expand new pages and features.",
      ],
    },
    {
      title: "Accessibility information for clinics",
      body: [
        "When available, family doctor and clinic profiles may include accessibility-related information such as wheelchair access, elevator access, accessible washrooms, and other accessibility features offered at the clinic.",
        "Clinics and family doctors are responsible for the information provided about their locations and services. AcceptingMD does not guarantee the accuracy or completeness of accessibility information provided by clinics or doctors.",
        "If you have specific accessibility needs, we recommend confirming details directly with the clinic.",
      ],
    },
    {
      title: "Known Limitations",
      body: [
        "We are actively improving the platform. Some content or features may not yet meet all accessibility standards in every area of the site.",
        "We prioritize accessibility improvements as part of ongoing development.",
      ],
    },
    {
      title: "Feedback and Support",
      body: [
        "If you encounter an accessibility or technical barrier while using AcceptingMD, please contact us and include the page URL (if possible), a brief description of the issue, the device and browser you are using, and any assistive technology involved (optional).",
        "We will do our best to respond and address the issue within a reasonable timeframe.",
      ],
    },
  ],

  ctas: {
    title: "Continue using AcceptingMD",
    subtitle: "Search participating family doctors or review how AcceptingMD protects your privacy.",
    primary: { label: "Find a Family Doctor", to: "/public/find-family-doctor" },
    secondary: { label: "Privacy Policy", to: "/public/privacy" },
  },
};
